import * as React from "react"
import BaseFormView, {BaseFormViewProps, BaseFormViewState} from "../../../ui/form/BaseFormView";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import HelpContactForm from "./form/HelpContactForm";
import HelpContactFormBody from "./HelpContactFormBody";
import User from "../../../../model/user/User";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import HelpRequest from "../../../../model/help/HelpRequest";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface ComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {HelpRequest} data
	 */
	onSubmit: (data: HelpRequest) => void
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * User Detail.
	 */
	user: User;
}


type Props = ComponentProps & BaseFormViewProps

type State = BaseFormViewState<HelpContactForm>

/**
 * Add new help contact form view.
 */
class AddHelpContactFormView extends BaseFormView<HelpContactForm, Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			form: HelpContactForm.createFromUser(this.props.user),
			shouldValidate: false,
			isFormDirty: false
		};
		this.submitForm = this.submitForm.bind(this);
	}

	render() {
		return (
			<div>
				<HelpContactFormBody form={this.state.form}
									 onFieldChange={this.onFieldChanged}
									 onFieldCompleted={() => {}}
									 onFocusChange={() => {}}
									 onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary label={"Cancel"}
									onClick={this.props.onCancel}/>
					<ButtonPrimary label={"Submit"} onClick={this.submitForm} isLoading={this.props.isLoading}/>
				</FormButtonsView>
			</div>
		);
	}

	/**
	 * Callback onSubmit button click.
	 */
	submitForm() {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit)
		});
	}

}

function mapStateToProps(state: RootState) {
	return {user: state.user.user.get};
}

export default connect(mapStateToProps)<ComponentProps & BaseFormViewProps>(AddHelpContactFormView)